<div
	class="schedule-hover-container freya-fc-hover p-overlaypanel"
	[style.width.px]="width"
	style="position: relative; display: block; min-width: 300px;"
>
	<div class="hover-start">
		<!-- Title -->
		<span
			class="hover-title"
			[style.backgroundColor]="colors.backgroundColor"
			[style.color]="colors.textColor"
		>
			<span *ngIf="assetNames">{{ assetNames }} - </span>{{ title }}
		</span>

		<!-- Job Info -->
		<div
			class="schedule-hover-section"
			[style.borderLeft]="'4px solid ' + colors.backgroundColor"
		>
			<span style="display: block; font-weight: bold; margin-bottom: 2px;">{{ customerName }}</span>
			<span
				class="schedule-hover-jobcode"
				*ngIf="jobCode"
			>{{ jobCode }}</span>
			<span style="display: block; margin-bottom: 2px;">{{ formattedTime }}</span>
			<span *ngIf="paymentInfo" style="display: block; margin-bottom: 2px;">{{ paymentInfo.discountedSubTotal / 100 | currency : paymentInfo.currency }} ({{ paymentInfo.paid / 100 | currency : paymentInfo.currency }} paid)</span>
			<div style="text-align: left; display: flex; align-items: center;">
				<i
					class="pi"
					[ngClass]="statusIcon"
				></i>
				<span style="margin-left: 4px;">{{ status }}</span>
				<span
					*ngIf="showWelcomeCall"
					class="welcome-call-indicator"
					title="Welcome call made"
				>W</span>
			</div>

			<table
				class="schedule-hover-attendees"
				*ngIf="attendees?.length"
			>
				<thead>
					<tr>
						<th>Name</th>
						<th>Role</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let attendee of attendees">
						<td>{{ formatUserName(attendee.user) }}</td>
						<td>{{ formatRole(attendee.role) }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- Crew Section -->
		<div
			class="schedule-hover-section"
			[style.borderLeft]="'4px solid ' + (colors.leftDivColor || 'var(--primary-color)')"
			style="margin: 5px 0; padding-left: 8px;"
			*ngIf="crewAttendees?.length || crewSize || product"
		>
			<span
				class="hover-title"
				style="display: block; font-weight: bold; margin-bottom: 4px;"
			>Crew</span>

            <div *ngIf="product" style="margin-bottom: 4px;">
                <span
                    class="schedule-hover-product-color"
                    [style.backgroundColor]="colors.leftDivColor || 'var(--primary-color)'"
                    [style.color]="colors.leftDivTextColor || 'var(--on-primary-color)'"
                    style="padding: 2px 4px; border-radius: 2px; font-weight: bold;"
                >
                    {{ product.name }}
                </span>
            </div>

			<div
				*ngIf="crewSize"
				style="margin-bottom: 4px; font-size: 0.9em;"
			>
				Required: {{ crewSize }} | Assigned: {{ crewAttendees?.length || 0 }}
			</div>

			<app-crew-list
				[crew]="crewAttendees"
				layout="row"
				displayFormat="fullname"
			></app-crew-list>
		</div>

		<!-- Financials Info -->
		<div
			class="schedule-hover-section"
			style="border: 2px solid var(--orange-500, #FF8C00); margin: 5px 0;"
		>
			<span
				class="hover-title"
				style="background-color: var(--orange-500, #FF8C00); color: var(--primary-color-text, #FFFFFF); margin-bottom: 4px; display: block;"
			>Financials</span>
			<ng-container *ngIf="financials; else noFinancials">
                <table class="financials-table" style="width: 100%;">
                    <tr>
                        <td>Charges</td>
                        <td style="text-align: right;">{{ financials.charges / 100 | currency : financials.currency }}</td>
                    </tr>
                    <tr *ngIf="financials.discounts">
                        <td>Discounts</td>
                        <td style="text-align: right;">{{ -financials.discounts / 100 | currency : financials.currency }}</td>
                    </tr>
                    <tr *ngIf="financials.discounts">
                        <td>Subtotal</td>
                        <td style="text-align: right;">{{ financials.discountedSubTotal / 100 | currency : financials.currency }}</td>
                    </tr>
                    <tr *ngIf="financials.taxes">
                        <td>Taxes</td>
                        <td style="text-align: right;">{{ financials.taxes / 100 | currency : financials.currency }}</td>
                    </tr>
                    <tr style="font-weight: bold; border-top: 1px solid #ccc;">
                        <td>Total</td>
                        <td style="text-align: right;">{{ financials.total / 100 | currency : financials.currency }}</td>
                    </tr>
                    <tr *ngIf="financials.paid">
                        <td>Paid</td>
                        <td style="text-align: right;">{{ -financials.paid / 100 | currency : financials.currency }}</td>
                    </tr>
                    <tr style="border-top: 1px solid #ccc;">
                        <td>Balance</td>
                        <td style="text-align: right;">{{ financials.balance / 100 | currency : financials.currency }}</td>
                    </tr>
                </table>
			</ng-container>
			<ng-template #noFinancials>
				<div>No financial data available</div>
			</ng-template>
		</div>


		<!-- Area / Locations -->
		<div
			class="schedule-hover-section"
			[style.border]="'2px solid ' + colors.zoneBackgroundColor"
		>
			<span
				class="schedule-hover-product-color"
				[style.backgroundColor]="colors.zoneBackgroundColor || '#FFFFFF'"
				[style.color]="colors.zoneTextColor"
			>
				{{ areaName }}
			</span>

			<table
				class="schedule-hover-locations"
				*ngIf="locations?.length"
			>
				<thead>
					<tr>
						<th colspan="2">Location</th>
						<th colspan="2">Time</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let loc of locations">
						<tr *ngIf="loc.location?.addressLineOne">
							<td colspan="3">
								{{ getLocationType(loc) }}
							</td>
							<td
								[attr.colspan]="loc.arrivalTime === loc.departureTime ? 2 : 1"
								class="time"
							>
								{{ formatLocationTime(loc.arrivalTime) }}
							</td>
						</tr>
						<tr>
							<td
								class="location-address"
								colspan="4"
							>
								{{ loc.location.addressLineOne }}
							</td>
						</tr>
						<tr>
							<td
								class="travel-to-next-destination"
								colspan="3"
							>
								{{ getTravelDuration(loc.estimatedTimeAtLocation) }}
							</td>
							<td
								*ngIf="loc.arrivalTime !== loc.departureTime"
								class="time"
							>
								{{ formatLocationTime(loc.departureTime) }}
							</td>
						</tr>
						<tr *ngIf="loc.travelToNextDestination > 300">
							<td
								class="travel-to-next-destination"
								colspan="4"
							>
								{{ getTravelDuration(loc.travelToNextDestination) }} to next destination
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>

	</div>
</div>